'use client';

import './styles/default.scss';

type GameplaySessionVideoSkeletonProps = {
    placeholderUrl?: string;
};

export const GameplaySessionVideoSkeleton = ({ placeholderUrl }: GameplaySessionVideoSkeletonProps) => {
    return (
        <div className="gs-video-skeleton" data-testid="gs-video-skeleton">
            {placeholderUrl && (
                <img
                    className="gs-video-skeleton-image"
                    src={placeholderUrl}
                    alt=""
                    aria-hidden="true"
                    loading="eager"
                    fetchPriority="high"
                />
            )}
        </div>
    );
};
